module.exports = __webpack_public_path__ + "static/07-acadia-zoom-b6744b6b59c4f103de657664a99857f2.jpg";